export const INT_WEB_CSV_TOAST_SEND_CAMPAIGN =
  "int_web_csv_toast_send_campaign";
export const INT_CREATE_OTC = "int_create_otc";
export const INT_CREATE_OGC = "int_create_ogc";
export const INT_CAMPAIGN_USER_FILTERING_FAILED =
  "int_campaign_user_filtering_failed";
export const INT_CAMPAIGN_NO_USERS_FOUND = "int_campaign_no_users_found";
